<template>
  <v-app>
    <v-dialog
      content-class="display-name-input"
      data-app
      v-model="nameDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-form @submit="onDisplayNameSubmit" @submit.prevent="onDisplayNameSubmit">
            <v-card-title>
              <span class="headline">Join live stream</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Display name*"
                      prepend-icon="mdi-account"
                      v-model="displayName"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="onDisplayNameSubmit"
                    type="submit"
                  >
                    OK
                  </v-btn>
            </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
<!--    display popup about missing query parameters in url, i.e. perhaps users didn't copy full url-->
    <v-dialog
      content-class="invalid-url-dialog"
      data-app
      v-model="invalidURLDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Incorrect URL address</span>
        </v-card-title>
        <v-card-text>
          URL address is missing info, most likely URL was not copied in its full form. Make sure additional parameters specified below are present at the end of the URL.
        </v-card-text>
        <v-card-text>
          The following parameters (channel, time) need to be present at the end of the URL, e.g.: ?channel=tCIYAQbwBFPmAYD3DahwnaMKz2y1&time=1626873930775
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--    display popup about unsupported browser and give option to open in other browser-->
    <v-dialog
      content-class="invalid-url-dialog"
      data-app
      v-model="showUnsupportedBrowserDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Unsupported browser</span>
        </v-card-title>
        <v-card-text>
          Your browser version is unsupported. Please use a different browser!
        </v-card-text>
      </v-card>
    </v-dialog>
    <VirtualStick
        ref="leftStick"
        id="leftStick"
        v-show="isDroneControlEnabled && !gamepad"
      />
    <VirtualStick
      ref="rightStick"
      id="rightStick"
      v-show="isDroneControlEnabled && !gamepad"
    />
    <Gamepad
      v-on:gamepadconnected="gamepadConnected"
      v-on:gamepaddisconnected="gamepadDisconnected"
      v-on:gamepadmovement="gamepadMovement"
    />
    <CameraGimbal
      ref="cameraGimbal"
      id="gimbalCameraControlStickArea"
      v-show="isGimbalCameraControlEnabled"
      v-on:onCameraGimbalStart="onCameraGimbalStart()"
      v-on:onCameraGimbalEnd="onCameraGimbalEnd()"
    />
    <video-player
      ref="videoPlayer"
      @onPlayerReady="onPlayerReady"
      :class="{minify: !mapMinified, maximize: mapMinified}"
      v-on:videoclicked="!mapMinified && switchMapVideo()"
    />
    <v-snackbar
      v-model="notificationDisplay"
      :timeout="notificationTimeout"
    >
      {{ notificationText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="notificationDisplay = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <div id="container">
      <div id="headerContainer">
        <ConnectionStatusToolbar v-if="mobile"></ConnectionStatusToolbar>
        <div id="bottomHeaderContainer">
            <div
                    v-if="buttonFullScreenShow"
                    id="buttonFullscreen"
                    @click="changeFullscreen"
            >
              {{ buttonFullscreenText }}
            </div>
            <ConnectionStatusToolbar v-if="!mobile"></ConnectionStatusToolbar>
            <img id="logo" src="@/assets/logo.svg" alt="DroneControl logo"/>
          </div>
        </div>
        <div id="contentContainer">
        <TakeOffWidget
          class="take-off-widget"
          v-show="showTakeOffWidget"
        />
        <ReturnHomeWidget
          class="return-home-widget"
          v-show="false"
        />
        <CameraControlsWidget
          class="camera-controls-widget"
          v-show="showCameraControlsWidget"
        />
      </div>
      <div id="footerContainer">
          <DroneMap
            id="droneMap"
            ref="droneMap"
            :class="{minify: mapMinified, maximize: !mapMinified}"
            v-on:mapclicked="mapMinified && switchMapVideo()"
          />
          <div id="telemetryAffiliateContainer">
            <Telemetry ref="telemetry" />
            <Affiliate ref="affiliate" />
          </div>
      </div>
    </div>
  </v-app>
</template>

<script>
  import { startViewer, stopViewer, sendViewerMessage } from './webRtcViewer'
  import VideoPlayer from "./components/VideoPlayer";
  import DroneMap from "./components/DroneMap";
  import Telemetry from "./components/Telemetry";
  import screenfull from "screenfull"
  import Affiliate from "./components/Affiliate";
  import VirtualStick from "./components/VirtualStick";
  import CameraGimbal from "./components/CameraGimbal";
  import Gamepad from "./components/Gamepad";
  import saveAs from 'file-saver';
  // eslint-disable-next-line no-unused-vars
  import adapter from "webrtc-adapter"
  import CameraControlsWidget from "./components/CameraControlsWidget";
  import TakeOffWidget from "./components/TakeOffWidget";
  import ReturnHomeWidget from "./components/ReturnHomeWidget";
  import ConnectionStatusToolbar from "./components/ConnectionStatusToolbar";

  const ROLL_PITCH_CONTROL_MAX_VELOCITY = 15;
  const VERTICAL_CONTROL_MAX_VELOCITY = 4;

  export default {
    name: 'PagesLive',
    components: {
      ConnectionStatusToolbar,
      ReturnHomeWidget,
      TakeOffWidget,
      CameraControlsWidget,
      Gamepad,
      CameraGimbal,
      VirtualStick,
      Affiliate,
      Telemetry,
      VideoPlayer,
      DroneMap,
    },
    data: () => ({
      mapMinified: true,
      nameDialog: true,
      invalidURLDialog: false,
      notificationDisplay: false,
      notificationText: "",
      notificationTimeout: 2000,
      displayName: '',
      videoStreamView: null,
      initialSetupMessage: true,
      buttonFullscreenText: 'Fullscreen',
      iceConnectionState: 'Disconnected',
      droneMovementIntervalId: null,
      cameraGimbalIntervalId: null,
      isAudioEnabled: false,
      gamepad: false,
      showUnsupportedBrowserDialog: false,
      receiveProgress: 0,
      receiveFileSize: 0,
      receiveFileName: '',
    }),
    computed: {
      buttonFullScreenShow: function () {
        return !(!screenfull.isEnabled || window.navigator.standalone || window.matchMedia('(display-mode: fullscreen)').matches);
      },
      isGimbalCameraControlEnabled: function () {
        return this.$store.state.featureStatus.isGimbalCameraControlEnabled === true;
      },
      isDroneControlEnabled: function () {
        return this.$store.state.featureStatus.isDroneControlEnabled === true;
      },
      showTakeOffWidget: function () {
        return this.isDroneControlEnabled && this.$store.state.takeOffWidget.takeOffLandingState !== 'DISCONNECTED' && !this.$store.getters.isReturningHome;
      },
      showCameraControlsWidget: function () {
        return this.$store.state.featureStatus.isTakePictureEnabled === true;
      },
      mobile() {
        return this.$vuetify.breakpoint.xs
      },
    },
    mounted () {
      const ref = this
      this.nameDialog = this.isURLValid();
      this.invalidURLDialog = !this.isURLValid();
      this.showUnsupportedBrowserDialog = !this.isBrowserSupported();

      let videoPlayer = this.$refs.videoPlayer;

      // override default behaviour for fullscreen as we are using screenful library and a special container to go fullscreen
      videoPlayer.player.exitFullscreen = function() {
        ref.changeFullscreen();
      }
      videoPlayer.player.requestFullscreen = function() {
        ref.changeFullscreen();
      }
      if (screenfull.isEnabled) {
        screenfull.onchange(function () {
          ref.buttonFullscreenText = screenfull.isFullscreen ? 'Exit fullscreen' : 'Fullscreen'
        })
      }
    },
    methods: {
      // check if opened URL is valid, i.e. contains correct query params
      isURLValid: function () {
        const urlParams = new URLSearchParams(window.location.search);
        const channelName = urlParams.get('channel');
        const creationTime = urlParams.get('time');

        return creationTime !== null && channelName !== null;
      },
      // check if used browser is supported by WebRTC adapter shim
      isBrowserSupported: function () {
        switch (adapter.browserDetails.browser) {
          // under chrome falls also edge as it uses chromium
          case 'chrome':
            return true;
          case 'firefox':
            return true;
          case 'safari':
            return true;
          default:
            this.$rollbar.warning('Viewer using unsupported browser: ' + adapter.browserDetails.browser + ', version: ' + adapter.browserDetails.version);
            return false;
        }
      },
      startStreaming() {
        // start streaming only when name dialog was already closed and video player is ready
        if (!this.nameDialog && this.videoStreamView) {
          const urlParams = new URLSearchParams(window.location.search);
          const channelName = urlParams.get('channel');
          const creationTime = urlParams.get('time');
          const channelARN = `arn:aws:kinesisvideo:eu-central-1:338245741198:channel/${channelName}/${creationTime}`
          let last = new Date();
          let receiveBuffer = [];
          let receivedSize = 0;

          startViewer(this.videoStreamView, channelARN, channelName, this.displayName, event => {
            // initial setup message from client
            if (this.initialSetupMessage) {
              this.initialSetupMessage = false;
              this.sendInitialSetupMessage();
            }

            const message = JSON.parse(event.data)

            // before sending files via separate datachannel, we need to send metadata, such as filesize and file name
            if (message.sendFile) {
              // todo: implement sending out message on android app that contains file info data, size, metadata, etc.
              this.receiveFileSize = message.sendFile.size;
              this.receiveFileName = message.sendFile.fileName;
            } else if ('isDegradationPreferenceSet' in message) {
              this.$store.commit("setDegradationPreference", message.degradationPreference);

              if (message.isDegradationPreferenceSet) {
                this.notificationText = "Network performance mode was successfully updated."
              } else {
                this.notificationText = "Network performance mode failed to update."
              }

              this.notificationDisplay = true
            } else if (this.$store.state.featureStatus.isGimbalCameraControlEnabled !== message.isGimbalCameraControlEnabled) {
              if (message.isGimbalCameraControlEnabled) {
                this.notificationText = "Drone pilot has just enabled remote gimbal camera movement. Press and hold anywhere on the screen to move the camera on the drone."
                this.notificationTimeout = 5000
                window.dispatchEvent(new Event("resize"));
              } else {
                this.notificationText = "Drone pilot has just disabled remote gimbal camera movement."
              }

              this.notificationDisplay = true
            } else if (this.$store.state.featureStatus.isDroneControlEnabled !== message.isDroneControlEnabled) {
              if (message.isDroneControlEnabled) {
                // send virtual stick movement data for remote drone control with frequency 10Hz
                if (!this.gamepad) {
                  this.droneMovementIntervalId = setInterval(function () {
                    let droneMovement = {
                      leftJoyStick: {radius: this.$refs.leftStick.radius * VERTICAL_CONTROL_MAX_VELOCITY, angle: this.$refs.leftStick.angle},
                      rightJoyStick: {radius: this.$refs.rightStick.radius * ROLL_PITCH_CONTROL_MAX_VELOCITY, angle: this.$refs.rightStick.angle},
                    };
                    sendViewerMessage(JSON.stringify({droneMovement}));
                  }.bind(this), 100);
                }

                if (this.gamepad) {
                  this.notificationText = "Drone pilot has just enabled remote drone control. Use connected gamepad to move the drone around."
                } else {
                  this.notificationText = "Drone pilot has just enabled remote drone control. Use displayed virtual joysticks to move the drone around."
                }
                this.notificationTimeout = 5000
                window.dispatchEvent(new Event("resize"));
              } else {
                if (this.droneMovementIntervalId != null) {
                  clearInterval(this.droneMovementIntervalId);
                }
                this.notificationText = "Drone pilot has just disabled remote drone control."
              }

              this.notificationDisplay = true
            } else if (this.$store.state.featureStatus.isTakePictureEnabled !== message.isTakePictureEnabled) {
              if (message.isTakePictureEnabled) {
                this.notificationText = "Drone pilot has just enabled remote camera shutter control. Use controls on the right side to take pictures or record video."
                this.notificationTimeout = 5000
              } else {
                this.notificationText = "Drone pilot has just disabled remote camera shutter control."
              }
              this.notificationDisplay = true
            }

            // save new values for comparison when next update arrives
            const updatedFeatureStatus = {
              'isGimbalCameraControlEnabled': message.isGimbalCameraControlEnabled,
              'isDroneControlEnabled': message.isDroneControlEnabled,
              // covering older mobile app versions that don't send feature status isTakePictureEnabled
              'isTakePictureEnabled': message.isTakePictureEnabled ?? false,
              'degradationPreference': message.degradationPreference ?? 'Balanced',
              'isDegradationPreferenceEnabled': 'degradationPreference' in message
            }
            this.$store.commit("setFeatureStatus", updatedFeatureStatus);
          }, event => {
            // todo: on file receive event, not yet implemented on native app side
            receiveBuffer.push(event.data);
            receivedSize += event.data.byteLength;
            this.receiveProgress.value = receivedSize;

            // is this the last transmission? the expected file size was received via separate datachannel before the
            // start of image transmission
            if (receivedSize === this.receiveFileSize) {
              const received = new Blob(receiveBuffer);
              receiveBuffer = [];

              // save retrieved image to disk
              saveAs(received, this.receiveFileName);
            }
          }, event => {
            const telemetry = JSON.parse(event.data)

            // update telemetry/affiliate component data
            this.$refs.telemetry.updateTelemetry(telemetry);
            this.$refs.affiliate.updateAircraftModel(telemetry.aircraftModel);
            this.isAudioEnabled = telemetry.isAudioEnabled

            const now = +new Date();

            // update map component only every 250 ms due to performance issues
            if (now - last > 250) {
              last = now;
              this.$refs.droneMap.updateMap(telemetry);
            }
            // eslint-disable-next-line no-unused-vars
          }, event => {
            switch (event.target.iceConnectionState) {
              // Docs:
              // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/iceconnectionstatechange_event
              // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/iceConnectionState
              case 'new':
                this.iceConnectionState = 'New'
                break
              case 'checking':
                this.iceConnectionState = 'Checking'
                break
              case 'connected':
                this.iceConnectionState = 'Connected'
                break
              case 'completed':
                this.iceConnectionState = 'Completed'
                break
              case 'failed':
                this.iceConnectionState = 'Failed'
                break
              case 'disconnected':
                // webrtc session disconnected, show dialog to user again and stop webrtc viewer connection
                this.nameDialog = true;
                stopViewer();

                this.iceConnectionState = 'Disconnected'
                this.notificationText = "Drone pilot has stopped streaming."
                this.notificationDisplay = true

                break
              case 'closed':
                this.iceConnectionState = 'Closed'
                break
            }
          });
        }
      },
      // when display name is submitted
      onDisplayNameSubmit() {
        this.nameDialog = false;
        this.startStreaming();

        // go full screen
        this.changeFullscreen();

        // go to landscape mode. On browsers that don't support it don't do anything
        window.screen.orientation.lock("landscape").catch(() => {});
      },
      // when player is ready store a reference to it
      onPlayerReady(videoStreamView) {
        this.videoStreamView = videoStreamView;
      },
      onCameraGimbalStart() {
        this.cameraGimbalIntervalId = setInterval(function() {
          let gimbalMovement = {};

          gimbalMovement['x'] = this.$refs.cameraGimbal.x;
          gimbalMovement['y'] = this.$refs.cameraGimbal.y;
          gimbalMovement['firstX'] = this.$refs.cameraGimbal.firstX;
          gimbalMovement['firstY'] = this.$refs.cameraGimbal.firstY;

          sendViewerMessage(JSON.stringify({ gimbalMovement }));
        }.bind(this), 100);
      },
      onCameraGimbalEnd() {
        if (this.cameraGimbalIntervalId != null) {
          clearInterval(this.cameraGimbalIntervalId);
        }
        sendViewerMessage(JSON.stringify({ gimbalMovementStop: true}));
      },
      onTakePicture() {
        sendViewerMessage(JSON.stringify({ takePicture: true }))
      },
      sendInitialSetupMessage() {
        sendViewerMessage(JSON.stringify({ initialSetup: { displayName: this.displayName }}));
      },
      changeFullscreen() {
        // check if screenful is enabled before toggling it
        if (screenfull.isEnabled) {
          screenfull.toggle(document.body);
        }
      },
      zoomIn(event) {
        if (event.deltaY < 0) {
          sendViewerMessage(JSON.stringify({ cameraZoomIn: true}));
        } else if (event.deltaY > 0) {
          sendViewerMessage(JSON.stringify({ cameraZoomOut: true}));
        }
      },
      gamepadConnected() {
        this.gamepad = true;
        this.notificationText = "Gamepad has just been connected. You can use it for remote drone control."
        this.notificationDisplay = true
      },
      gamepadDisconnected() {
        this.gamepad = false;
        this.notificationText = "Gamepad has just been disconnected."
        this.notificationDisplay = true
      },
      gamepadMovement(leftJoyStick, rightJoyStick) {
        if (this.$store.state.featureStatus.isDroneControlEnabled) {
          let droneMovement = {
            leftJoyStick: {radius: leftJoyStick.radius, angle: leftJoyStick.angle},
            rightJoyStick: {radius: rightJoyStick.radius, angle: rightJoyStick.angle},
          };
          sendViewerMessage(JSON.stringify({droneMovement}));
        }
      },
      switchMapVideo() {
        // todo: this feature is currently not supported
        // this.mapMinified = !this.mapMinified;
        //
        // let video = document.getElementById('video-stream');
        // let droneMap = document.getElementById('droneMap');
        //
        // this.swapElements(droneMap, video);
        //
        // if (!this.mapMinified) {
        //   video.classList.add('minify');
        //   video.classList.remove('maximize');
        // } else {
        //   video.classList.add('maximize');
        //   video.classList.remove('minify');
        // }
        //
        // // set map size and call resize function
        // this.$refs.droneMap.resizeMap();
      },
      swapElements(obj1, obj2) {
          // save the location of obj2
          var parent2 = obj2.parentNode;
          var next2 = obj2.nextSibling;
          // special case for obj1 is the next sibling of obj2
          if (next2 === obj1) {
              // just put obj1 before obj2
              parent2.insertBefore(obj1, obj2);
          } else {
              // insert obj2 right before obj1
              obj1.parentNode.insertBefore(obj2, obj1);

              // now insert obj1 where obj2 was
              if (next2) {
                  // if there was an element after obj2, then insert obj1 right before that
                  parent2.insertBefore(obj1, next2);
              } else {
                  // otherwise, just append as last child
                  parent2.appendChild(obj1);
              }
          }
      }
    },
  }
</script>

<style>
html, body {
  min-height: 100%;
  height: 100%;
  margin: 0;
}

#container {
  background-color: black;
  font-family: 'Roboto', sans-serif;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header"
    "content"
    "footer";
  grid-template-rows: auto 20%;  /* Footer should have 20% height. */
  align-content: space-between;      /* vertical alignment of grid tracks */
}

#bottomHeaderContainer {
  display: flex;
  justify-content: space-between;
}

#contentContainer {
  display: flex;
  height: 100%;
}

#footerContainer {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  height: 100%;
  width: 100%;
}

.minify {
  z-index: 20;
  width: 20%;
  margin: 10px;
  height: 100%;
}

.maximize {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}

.camera-controls-widget {
  width: 3%;
  z-index: 20;
  margin-left: auto;
  margin-right: 10px;
}

.take-off-widget {
  width: 3%;
  z-index: 20;
  margin-left: 10px;
  margin-right: auto;
}

@media screen and (min-width: 320px) and (max-width: 1024px) {
    .camera-controls-widget {
        width: 8%;
    }
    .take-off-widget {
        width: 8%;
    }
}

#telemetryAffiliateContainer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 100%;
  margin: 10px;
}

#gimbalCameraControlStickArea {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 18;
}

#buttonFullscreen {
  margin: 20px;
  padding: 5px;
  color: white;
  border: 1px solid white;
  border-radius: 5px;
  z-index: 20;
  cursor: pointer;
}

#logo {
  margin: 20px;
  width: 12rem;
  z-index: 20;
}

#leftStick {
  position: absolute;
  top: 50%;
  left: 20%;
  z-index: 19;
}

#rightStick {
  position: absolute;
  top: 50%;
  right: 20%;
  z-index: 19;
}

a, a:visited, a:active, a:hover {
  color: white;
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .display-name-input {
    transform: scale(0.8);
  }

  .minify {
    width: 35%;
  }
}

.display-name-input {
  z-index: 2147483648;
}

.v-snack:not(.v-snack--absolute) {
  z-index: 2147483648;
}


</style>
